import { create } from 'zustand';

import { FeatureFlagEnum, flagKeyMap, TFeaturesResponse } from '../types';

interface IFeatureFlagsStore {
  data: TFeaturesResponse;
  setter: (data: TFeaturesResponse) => void;
  checkFeature: (feature: FeatureFlagEnum, defaultVaule?: boolean) => boolean;
}

export const useFeatureFlagsStore = create<IFeatureFlagsStore>((set, get) => ({
  data: [],
  setter: (data) => {
    set({ data });
  },
  checkFeature: (feature: FeatureFlagEnum, defaultValue: boolean = false) => {
    const key = flagKeyMap[feature];
    const features = get().data;
    return features.includes(key) ? true : defaultValue;
  },
}));
